import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { couponsApiPath } from './apiPath';

const GetCouponsCountRequestParamsSchema = z
  .object({
    shopTitle: z.string(),
  })
  .describe('큐레이터 활동명. =snsTitle');

export type GetCouponsCountRequestParams = z.infer<typeof GetCouponsCountRequestParamsSchema>;
/**
 * 큐레이터 발급 가능 쿠폰 개수 조회 응답 스키마
 * 엔드포인트: GET /v2/curators/coupons/count
 */
export const GetCouponsCountSchema = z.object({
  totalCount: z.number().int().nonnegative().describe('전체 쿠폰 개수'),
  availableCount: z.number().int().nonnegative().describe('발급 가능 쿠폰 개수'),
});

export const GetCouponsCountResponseSchema = createApiResponseSchema(GetCouponsCountSchema);
export type GetCouponsCountResponse = z.infer<typeof GetCouponsCountResponseSchema>;

export const getCouponCount = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCouponsCountRequestParamsSchema),
    async ({ shopTitle }: GetCouponsCountRequestParams): Promise<GetCouponsCountResponse> => {
      const response = await privateHttpClient.get<GetCouponsCountResponse>(
        couponsApiPath.getCouponsCount,
        {
          shopTitle,
        },
      );
      return response.data;
    },
    validateApiResponse(GetCouponsCountResponseSchema),
  ),
);
